import React, { useEffect, useRef } from 'react';
import { Header, Wrap, Content } from './FeedbackStyled';
import { ReactComponent as Comment } from './icons/comment-text.svg';
import FeedbackForm from './FeedbackForm';

const FeedbackModal = (props: { target: React.MutableRefObject<HTMLDivElement | null> }) => {
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const rect = props.target.current!.getBoundingClientRect();
    wrapRef.current?.setAttribute(
      'style',
      `bottom:${window.innerHeight - rect.bottom}px; right: ${window.innerWidth - rect.left + 24}px`,
    );
  }, []);

  return (
    <Wrap ref={wrapRef}>
      <Header>
        <Comment style={{ marginRight: 16 }} />
        <div>Предложите идею по улучшению сервиса или задайте вопрос</div>
      </Header>
      <Content>
        <FeedbackForm />
      </Content>
    </Wrap>
  );
};

export default FeedbackModal;
